import { TaskStatus } from '../models/TaskStatus';
var ProjectStatistics = /** @class */ (function () {
    function ProjectStatistics(from) {
        var _this = this;
        this.userStatistics = from.userStatistics;
        this.userChartData = from.userChartData;
        this.taskChartData = {};
        Object.keys(from.taskChartData).forEach(function (key) {
            _this.taskChartData[TaskStatus.stringify(parseInt(key, 10))] = from.taskChartData[key];
        });
    }
    return ProjectStatistics;
}());
export default ProjectStatistics;



//////////////////
// WEBPACK FOOTER
// ./src/models/ProjectStatistics.ts
// module id = 373
// module chunks = 0